import {Fragment, h} from "preact";
import s from "./attendancePicker.module.css";
import {useAttendancePicker} from "./useAttendancePicker";
import DefaultPicker from "./DefaultPicker";
import HomeDeliveryPicker from "./HomeDeliveryPicker";
import {useAppContext} from "../../../../../contexts";
import {iconNewAttendance, nadWhiteArrow} from "../../../../../assets";

const AttendancePicker = props => {
    // Destructured props
    const {
        attendance,
        selectedAttendanceType,
        handleAttendance,
        singleAttendanceType,
        formKey,
        product,
        setOpenTermUse,
        categories,
        globalFreeFreight,
        productCategoryServiceType,
        handleCartLoader,
        handleCurrentStep,
        sidebarCartData
    } = props;

    // Component logic data
    const componentProps = useAttendancePicker({
        attendance,
        formKey,
        product,
        setOpenTermUse,
        categories,
        handleCurrentStep,
        sidebarCartData,
        handleCartLoader,
        selectedAttendanceType
    });

    // Destructured component logic data
    const {
        HEADING_TITLES,
        selectedAmount,
        handleSubmit,
        selectedValue,
        errors,
        handleSelectedValue,
        hasSubmitted,
        handleErrors,
        isAddingToCart,
        isFreeFreight,
        handleIsFreeFreight,
        errorMessage,
        handleSelfServiceAttendanceModal
    } = componentProps;

    // The heading title that will be displayed according to the attendance type
    const headingTitle = HEADING_TITLES[attendance.label];

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Prevents component from rendering if no regions are available
    if (
        attendance.regions.length < 1 &&
        attendance.label !== "home_delivery"
    ) {
        return null;
    }

    // The container content block
    const pickerContent = attendance.label !== "home_delivery" ? (
        <DefaultPicker
            attendanceType={attendance.label}
            selectedValue={selectedValue}
            errors={errors}
            handleSelectedValue={handleSelectedValue}
            hasSubmitted={hasSubmitted}
            handleErrors={handleErrors}
            items={attendance.items}
            errorMessage={errorMessage}
            attendance={attendance}
        />
    ) : (
        <HomeDeliveryPicker
            attendanceId={attendance.items[0].id}
            headingTitle={headingTitle}
            selectedAmount={selectedAmount}
            additionalErrors={errors}
            handleSelectedValue={handleSelectedValue}
            handleErrors={handleErrors}
            handleIsFreeFreight={handleIsFreeFreight}
            handleCartLoader={handleCartLoader}
        />
    );

    // The actual form
    const attendanceForm = (
        <form
            onSubmit={handleSubmit}
            className={`
                discrete-scrollbar light-discrete-scrollbar 
                ${attendance.label !== "home_delivery" ? s.contentContainer : s.homeDeliveryContentContainer}
                ${selectedAttendanceType === attendance.label ? "" : " hidden"}
                ${highContrast ? "highGrayColor border-x border-b border-[#666]" : ""}
            `}
        >
            <p className={`
                ${attendance.label !== "home_delivery" ? s.headingTitle : s.homeDeliveryHeadingTitle}
                ${highContrast ? "highLabelFourth" : ""}
            `}>
                {attendance.label !== "home_delivery" ? "Escolha o local:" : headingTitle}
            </p>

            {/* The picker block */}
            {pickerContent}
        </form>
    );

    // The variable name already says it all
    const freightDisclaimer = attendance.label === "home_delivery" ?
        isFreeFreight || globalFreeFreight ? (
            <Fragment>
                {/*<div className={`${s.freeFreight} ${highContrast ? "highLabelWrapper" : ""}`}>*/}
                {/*    Isento de taxa*/}
                {/*</div>*/}
                {/*<div className={`text-[#02BE83] text-[12px] font-normal ${highContrast ? "highLabelWrapper" : ""}`}>*/}
                {/*    Isento de taxa*/}
                {/*</div>*/}
            </Fragment>
        ) : (
            <p
                className={`text-sabin-red-default text-[12px] font-normal ${highContrast ? "highLabelFourth" : ""}`}>
                + Taxa de Serviço
            </p>
        ) : null;

    // Tour button for the self-service attendance type
    const tourButton =
        attendance.label !== "self_service" ? null : (
            <button
                type={"button"}
                className={`${s.tourButton}`}
                onClick={() => handleSelfServiceAttendanceModal(true)}
            >
                Faça o tour virtual na unidade
            </button>
        );

    // Add to cart button for the self-service attendance type
    const selfServiceSubmitButton =
        selectedAttendanceType &&
        selectedAttendanceType === "self_service" &&
        attendance.label === "self_service" ? (
            <button
                type={"button"}
                className={`${s.submitButton}`}
                onClick={() => handleSubmit()}
            >
                Adicionar ao carrinho
                <img
                    src={nadWhiteArrow}
                    className={s.whiteArrow}
                    alt={"White arrow"}
                />
            </button>
        ) : null;

    // Classes for the root element
    const rootClasses =
        selectedAttendanceType &&
        selectedAttendanceType !== attendance.label &&
        selectedAttendanceType !== "self_service" ?
            "hidden" :
            selectedAttendanceType &&
            selectedAttendanceType !== attendance.label &&
            selectedAttendanceType === "self_service" ?
                "opacity-50" :
                "";

    return (
        <Fragment>
            <div
                className={`
                    w-full ${rootClasses}
                `}>
                <div
                    className={`
                        attendance-picker 
                        ${s.attendanceButton} 
                        ${attendance.label === "self_service" ? s.selfServiceAttendance : ""} 
                        ${(selectedAttendanceType === attendance.label && selectedAttendanceType !== "home_delivery" && selectedAttendanceType !== "self_service") ? `${s.noBottomRadius}` : ""}
                        ${highContrast ? "highGrayColor border border-[#666]" : ""}
                    `}
                    onClick={() => handleAttendance({
                        type: !selectedAttendanceType ? attendance.label : ""
                    })}
                >
                    <div className={`
                        ${s.attendanceButtonContent}
                        ${highContrast ? "highTitleThird" : ""}
                        ${attendance.uppercase ? "uppercase" : ""}
                    `}>
                        <input
                            type={"radio"}
                            id={`${attendance.label}-attendance`}
                            name={"attendance-types"}
                            checked={singleAttendanceType || selectedAttendanceType === attendance.label}
                            data-testid="attendance-picker-input"
                        />
                        <img
                            src={attendance.icon}
                            className={s.attendanceIcon}
                            alt={"Attendance type icon"}
                            data-testid="attendance-picker-image"
                        />
                        <div className={"w-full flex flex-col items-start justify-between gap-y-0.5 py-2"}>
                            <span data-testid="attendance-picker-name">
                                {attendance.name}
                            </span>
                            {/* Free freight warning for the home delivery attendance type */}
                            {freightDisclaimer}
                            {attendance.label !== "self_service" ? null : (
                                <Fragment>
                                    <img
                                        src={iconNewAttendance}
                                        alt="New attendance icon"
                                        className={`absolute top-[8px] right-[16px]`}
                                    />
                                    <span className={`text-[#545454] text-[12px] font-[600] uppercase`}>
                                        {attendance.regions[0].items[0].label}
                                    </span>
                                </Fragment>
                            )}
                        </div>
                    </div>

                    {/* Self service attendance tour button */}
                    {tourButton}
                </div>
                {attendance.label !== "self_service" ? attendanceForm : null}
            </div>

            {selfServiceSubmitButton}
        </Fragment>
    )
}

export default AttendancePicker;
